import { createSelector } from 'reselect';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';

const getPopularLocationsOneCmsUrlSelector = createSelector(
  getActiveLocaleSelector,
  (activeLocale) => `Internet/travel/common/${activeLocale.toLowerCase()}/popular-locations.json`);

export default getPopularLocationsOneCmsUrlSelector;
